import React from "react";
import AwardAccountSummaryGLTable from "./AwardAccountSummaryGLTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const AwardAccountSummaryGLIndex = () => (
  <ReportProgramsPage
    TableComponent={AwardAccountSummaryGLTable}
    loadingMessage="Loading award account summary GL..."
  />
);

export default AwardAccountSummaryGLIndex;
